<div #dropdown>
    <button
        appNavItem
        [position]="position"
        class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2 nav-item company-colors"
        [class.active]="(open$ | async) || (active$ | async)"
        appMenuButton
        [dropdownEl]="dropdown"
        [ariaControls]="listId"
        type="button"
        data-test="nav-admin-button"
    >
        <div>
            <app-icon name="gear-trunc" class="tw-size-5" />
        </div>
        <div class="tw-flex tw-items-center tw-gap-1">
            <span class="nav-item-text">
                {{ 'v3-role-admin' | translate }}
            </span>
            <app-icon
                name="point-arrow-down"
                class="point-arrow-down-icon"
                [ngClass]="{
                    rotate: open$ | async,
                }"
            />
        </div>
    </button>

    <app-nav-item-admin-list [open]="open$ | async" />
</div>
